import { FC } from 'react';
import { AiOutlineLeft, AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineRight } from 'react-icons/ai';

interface APaginationInlineProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

const APaginationInline: FC<APaginationInlineProps> = ({ 
        currentPage, 
        totalPages, 
        onPageChange,
    }) => {

    const pagesToShow = 10;
    const pageStart = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
    const pageEnd = Math.min(totalPages, pageStart + pagesToShow - 1);

    return (
        <ul className="inline-flex -space-x-px text-sm h-8 flex-none flex-nowrap">
            <li>
                <button
                    className={`flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 ${currentPage === 1 ? 'cursor-not-allowed opacity-50' : 'hover:cursor-pointer'}`}
                    onClick={() => onPageChange(1)}
                    title='Primeira página'
                    disabled={currentPage === 1}
                >
                    <AiOutlineLeft />
                </button>
            </li>
            <li>
                <button
                    className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${currentPage === 1 ? 'cursor-not-allowed opacity-50' : 'hover:cursor-pointer'}`}
                    onClick={() => onPageChange(currentPage - 1)}
                    title='Página anterior'
                    disabled={currentPage === 1}
                >
                    <AiOutlineDoubleLeft />
                </button>
            </li>
            {Array.from({ length: pageEnd - pageStart + 1 }, (_, index) => {
                const pageNumber = pageStart + index;
                return (
                    <li key={pageNumber}>
                        <button
                            title={pageNumber === currentPage ? 'Página atual' : `Ir para página ${pageNumber}`}
                            onClick={() => onPageChange(pageNumber)}
                            className={`flex items-center justify-center px-3 h-8 leading-tight ${pageNumber === currentPage
                                ? 'text-blue-600 bg-blue-50'
                                : 'text-gray-500 bg-white'
                                } border border-gray-300 hover:bg-gray-100 hover:text-gray-700`}
                        >
                            {pageNumber}
                        </button>
                    </li>
                );
            })}
            <li>
                <button
                    className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${currentPage === totalPages ? 'cursor-not-allowed opacity-50' : 'hover:cursor-pointer'}`}
                    onClick={() => onPageChange(currentPage + 1)}
                    title='Próxima página'
                    disabled={currentPage === totalPages}
                >
                    <AiOutlineDoubleRight />
                </button>
            </li>
            <li>
                <button
                    className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 ${currentPage === totalPages ? 'cursor-not-allowed opacity-50' : 'hover:cursor-pointer'}`}
                    onClick={() => onPageChange(totalPages)}
                    title='Última página'
                    disabled={currentPage === totalPages}
                >
                    <AiOutlineRight />
                </button>
            </li>
        </ul>
    );
};

export default APaginationInline;